/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import {graphql, useStaticQuery} from "gatsby"
import {Helmet} from "react-helmet"
import SEO from "./seo"
import Header from "./header"
import Footer from "./footer"
import CookieLand from "./cookieland";
import favicon from '../../img/favicon.ico'
import Feder from "./feder";
import ModalDexga from "./modal-dexga";

const Layout = ({children, pageContext, cookies}) => {

    const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

    return (
        <>
            <Helmet
                defer={false}
                title="Tecalis">
                <link rel="icon" href={favicon}/>
                {/*<script src="https://kit.fontawesome.com/dd5f5ce6f3.js" crossOrigin="anonymous"/>*/}
                <script src={`https://www.google.com/recaptcha/api.js?r=${Math.random()}`} async defer/>
                <link rel="stylesheet" href="https://use.typekit.net/acr2trl.css"/>
            </Helmet>

            <SEO lang={pageContext.locale.path.default}/>

            <Header siteTitle={data.site.siteMetadata.title} pageContext={pageContext}/>
            {children}
            <ModalDexga/>
            {cookies && <CookieLand data={cookies} pageContext={pageContext}/>}
            <Feder/>
            <Footer pageContext={pageContext}/>
        </>
    )
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout
